import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Onderwerp", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Ruimte", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Omschrijving", -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Aanvullende informatie", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Gewenste oplossing", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Toegepaste oplossing", -1)
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Media", -1)

import { issueStore } from '@/stores/issue'
import Filelist from '@/components/Filelist.vue'
import axios from 'axios'
import { useRoute } from 'vue-router'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShowDetailsCard',
  setup(__props) {

const route = useRoute()
const downloading = ref(false)

function downloadPdf () : void {
  downloading.value = true

  // Only solver type is supported.
  const payload = {
    types: ['solver']
  }
  axios.post(`${process.env.VUE_APP_API_URL}/issues/${route.params.issueId}/export`, payload, { responseType: 'blob' })
    .then(r => {
      const blob = new Blob([r.data], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Export_Servicemelding_' + route.params.issueId + '.pdf'
      link.click()
    })
    .finally(() => {
      downloading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Details",
    bordered: false
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_a_button, { onClick: downloadPdf }, {
        default: _withCtx(() => [
          _createTextVNode("Download PDF")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (!_unref(issueStore)().issue)
        ? (_openBlock(), _createBlock(_component_a_skeleton, {
            key: 0,
            active: ""
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: {span: 24},
                  sm: {span: 24},
                  md: {span: 24},
                  lg: {span: 12}
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createElementVNode("p", null, _toDisplayString(_unref(issueStore)().issue.title), 1)
                  ]),
                  _: 1
                }),
                (_unref(issueStore)().issue.room)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 0,
                      xs: {span: 24},
                      sm: {span: 24},
                      md: {span: 24},
                      lg: {span: 12}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createElementVNode("p", null, _toDisplayString(_unref(issueStore)().issue.room.name) + ", " + _toDisplayString(_unref(issueStore)().issue.room.level_name), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createElementVNode("div", {
                      innerHTML: _unref(issueStore)().issue.description
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(issueStore)().issue.additional_info)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createElementVNode("div", {
                          innerHTML: _unref(issueStore)().issue.additional_info
                        }, null, 8, _hoisted_7)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(issueStore)().issue.recommended_solution)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createElementVNode("div", {
                          innerHTML: _unref(issueStore)().issue.recommended_solution
                        }, null, 8, _hoisted_9)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(issueStore)().issue.implemented_solution)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createElementVNode("div", {
                          innerHTML: _unref(issueStore)().issue.implemented_solution
                        }, null, 8, _hoisted_11)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(issueStore)().issue.files.length)
              ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createElementVNode("div", null, [
                          _createVNode(Filelist, {
                            media: _unref(issueStore)().issue.files
                          }, null, 8, ["media"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }))
}
}

})